export interface ITotals {
  costTotal?: number;
  discountTotal?: number;
  discountTotalPct?: number;
  discountTotalRatio?: number;
  marginTotal?: number;
  marginTotalPct?: number;
  marginTotalRatio?: number;
  priceNettTotal?: number;
  vatEstTotal?: number;
}
